/**
 * Legacy-Redirect: /webhook_events → /developer/webhooks
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/webhook_events')({
  beforeLoad: () => {
    throw redirect({ to: '/developer/webhooks', replace: true })
  },
  component: () => null,
})
